import { useState } from 'react';
import Header from '../components/Header.jsx';
import { api } from '../lib/api.js';

export default function OverlapScreen({ device, existing, attemptedCathayId, onCancel, onResolved }) {
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const endPrevious = async () => {
    setBusy(true);
    setErr(null);
    try {
      // Close the prior session (server records auto_close_reason = 'overlap_force_close').
      await api.forceClose(existing.id);
      // Bubble back so caller can retry the sign-in.
      onResolved();
    } catch (e) {
      setErr(e.message || 'Failed to close previous session');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-slate-100">
      <Header deviceName={device?.name} />
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-xl bg-white rounded-3xl shadow-xl p-8 space-y-6">
          <header className="text-center">
            <div className="inline-block bg-amber-100 text-amber-800 text-kiosk font-semibold rounded-full px-4 py-1 mb-3">
              IPT in use
            </div>
            <h1 className="text-kiosk-lg font-semibold text-cathay-700">
              Another sign-in is already active
            </h1>
            <p className="text-kiosk text-slate-600 mt-2">
              CathayID currently signed in:
            </p>
            <div className="font-mono text-kiosk-xl tracking-widest text-slate-800 mt-2">
              {existing?.cathay_id_masked || '????'}
            </div>
            <p className="text-kiosk text-slate-600 mt-4">
              You entered:
              <span className="font-mono text-slate-800 ml-2">{attemptedCathayId}</span>
            </p>
          </header>

          {err && (
            <div className="bg-red-50 border border-red-200 text-red-700 rounded-2xl px-4 py-3 text-kiosk">
              {err}
            </div>
          )}

          <div className="grid grid-cols-1 gap-3">
            <button
              onClick={endPrevious}
              disabled={busy}
              className="bg-cathay-500 hover:bg-cathay-600 disabled:opacity-60 text-white text-kiosk-lg font-semibold py-5 rounded-2xl shadow"
            >
              {busy ? 'Closing previous…' : 'End previous & start mine'}
            </button>
            <button
              onClick={onCancel}
              className="bg-white hover:bg-slate-100 border border-slate-300 text-slate-700 text-kiosk-lg font-semibold py-5 rounded-2xl"
            >
              Cancel
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
